import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { CATEGORIES } from "../data/site";

export const Inventory = () => (
  <section
    id="carry"
    data-testid="carry-section"
    className="relative scroll-mt-20 border-t border-zinc-800/60 py-20 lg:py-28"
  >
    <div
      aria-hidden="true"
      className="absolute right-0 top-1/3 h-72 w-72 rounded-full bg-yellow-600/[0.05] blur-[110px]"
    />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="eyebrow" data-testid="carry-eyebrow">
          Inventory
        </p>
        <h2
          data-testid="carry-heading"
          className="mt-3 font-display text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl"
        >
          What We Carry
        </h2>
        <p className="mt-4 max-w-2xl leading-relaxed text-zinc-400">
          From TCG staples to sports cards and supplies, the Sandstorm Trading
          inventory is always growing. Tap a category to browse it in our
          storefronts — links open in a new tab.
        </p>
      </Reveal>
      <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {CATEGORIES.map((c, i) => (
          <Reveal key={c.id} delay={i * 0.04}>
            <a
              href={c.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`category-tile-${c.id}`}
              aria-label={`Browse ${c.name} in the Sandstorm Trading storefront — opens in a new tab`}
              className="group relative block h-full rounded-xl border border-zinc-800 bg-[#12141A] p-6 transition-[border-color,box-shadow,transform] duration-300 hover:-translate-y-1 hover:border-amber-500/40 hover:shadow-[0_0_30px_rgba(212,175,55,0.1)]"
            >
              <span
                aria-hidden="true"
                className="absolute left-2.5 top-2.5 h-3 w-3 border-l border-t border-amber-500/40 transition-colors group-hover:border-amber-400"
              />
              <span
                aria-hidden="true"
                className="absolute bottom-2.5 right-2.5 h-3 w-3 border-b border-r border-amber-500/40 transition-colors group-hover:border-amber-400"
              />
              <ArrowUpRight
                className="absolute right-3 top-3 h-4 w-4 text-amber-400/40 transition-colors duration-300 group-hover:text-amber-300"
                aria-hidden="true"
              />
              <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.3em] text-amber-400/80">
                {c.code}
              </p>
              <h3 className="mt-3 font-display text-lg font-semibold leading-snug text-zinc-100">
                {c.name}
              </h3>
              <p className="mt-2 text-sm text-zinc-500">{c.note}</p>
            </a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
